/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button as MuiButton } from "@mui/material";
import { Helmet } from "react-helmet";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
import useParamsQuery from "../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../redux/selectors/user";
import Reports from "../../../services/api/reports";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import styles from "./Subsriptionstyles";
import ReportTable from "./ReportsTable/SubsriptionTable";
import OrganizationSearch from "./OrganizationSearchReports";
import PersonalDetailsSearch from "./personalDetailsSearch";
import {
  getFilters,
  getFormattedQuery,
  getRoutePath,
  handleDependencyFilter,
  performOperation,
} from "./utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import ExportSubscription from "./Components/ExportSubscription";
import Toast from "../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function SubscriptionReports() {
  const TITLE = "Subscription Reports - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    if (disabledOSKeys && Array.isArray(disabledOSKeys)) {
      updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    }

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (
    queryParams,
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
        pageNumber,
        pageSize,
      });

      const { data } = await Reports.SubscriptionSearchReport(formattedQuery);

      setTimeout(() => {
        setSearchData(data.content);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
        setPageSize(pageSize);
        setIsLoading(false);

        if (data.content?.length > 0) {
          if (allowModalRef.current) {
            setOpenResultModal(true);
            setShowSearchResult(true);
            allowModalRef.current = false;
          }
        } else {
          setShowToast({
            severity: "error",
            message: "No data found",
          });
          setOpenResultModal(false);
          setShowSearchResult(false);
          allowModalRef.current = false;
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    formData.pageNumber = 0;
    formData.pageSize = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      if (
        queryObject.pageNumber !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params?.pageNumber, params?.pageSize);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      Array.isArray(disabledOSKeys) &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params?.pageNumber, params?.pageSize);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Export + Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <ExportSubscription
                    data={searchData}
                    exportFunction={Reports.downloadSubscriptionReports}
                  />
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <ReportTable
                  searchData={searchData}
                  currentPage={currentPage}
                  pageSize={pageSize}
                />
              </div>

              {/* Pagination */}
              {searchData.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <Pagination
                    totalPages={totalPages}
                    totalResults={totalElements}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
              )}
            </>
          ) : null}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default SubscriptionReports;
